import site from './content/siteContent.json';
import policy from './content/bookingPolicies.json';
import { cancellationAnswer } from './components/BookingPolicies';
export const businessInfo = {
  "name": "VVPSS Pvt. Ltd. Taxi Services",
  "tagline": "Tempo Traveller & Taxi Service in Satna",
  "established": "2010",
  "phone1": site.phone,
  "phone2": "9685764656",
  "phone3": "9425712055",
  "email": "vvpsspvtltdtaxiservices@gmail.com",
  "address": "Beside Sanyasi Baba, Ward 31, Jawahar Nagar, Satna, Madhya Pradesh, India - 485001",
  "whatsapp": site.whatsapp,
  "logo": "https://hiretempotravellersatna.com/logo.png?v=badge-e75c0e4c89f4",
  "hours": "Contact us to confirm reporting time and availability"
};
export const services = [
  {
    "id": 1,
    "title": "Taxi Service & Cab Booking",
    "description": "Request local pickups, station transfers or outstation cab booking. Share addresses and waiting requirements for a complete quotation.",
    "icon": "MapPin"
  },
  {
    "id": 2,
    "title": "Car Rental & Car Hire",
    "description": "Compare sedan, SUV and MPV options for family or business travel. Confirm passengers, luggage and travel dates before booking.",
    "icon": "Briefcase"
  },
  {
    "id": 3,
    "title": "Tempo Traveller on Hire / Rental",
    "description": "Choose 13, 17, 20, 21 or 26 total seats including the driver for your group. Confirm the passenger layout and luggage space.",
    "icon": "Route"
  },
  {
    "id": 4,
    "title": "One Way Taxi & Round Trip",
    "description": "Share the pickup, final drop and return plan. Obtain the complete garage-to-garage fare and all extras in writing.",
    "icon": "Plane"
  },
  {
    "id": 5,
    "title": "Family Tour & Group Transportation",
    "description": "Coordinate family journeys, wedding guest pickups and group transfers with all stops, passengers and bags included in the plan.",
    "icon": "Heart"
  },
  {
    "id": 6,
    "title": "Tourist Sightseeing & Pilgrimage Tours",
    "description": "Plan sightseeing or darshan stops with realistic waiting and return times. Confirm tickets, access and activities separately from road transport.",
    "icon": "Camera"
  }
];
export const testimonials = [];
export const whyChooseUs = [
  {
    "id": 1,
    "title": "Direct booking contact",
    "description": "Discuss the itinerary by phone or WhatsApp before confirming travel.",
    "icon": "Clock"
  },
  {
    "id": 2,
    "title": "Vehicle details first",
    "description": "Request the assigned model, photo and passenger capacity before booking.",
    "icon": "ShieldCheck"
  },
  {
    "id": 3,
    "title": "Plan for your group",
    "description": "Discuss luggage, boarding needs and rest stops with the booking team.",
    "icon": "Shield"
  },
  {
    "id": 4,
    "title": "Written quotation",
    "description": "Check minimum running, waiting, driver charges and other inclusions.",
    "icon": "IndianRupee"
  },
  {
    "id": 5,
    "title": "Satna-based coordination",
    "description": "Confirm vehicle positioning and availability for pickups in other cities.",
    "icon": "Award"
  },
  {
    "id": 6,
    "title": "Clear travel plan",
    "description": "Agree on the pickup, stops and final drop so the quotation covers the whole journey.",
    "icon": "Sparkles"
  }
];
export const faqs = [...site.homeFaqs,
  { id: 'customer-cancellation', question: 'What is the cancellation and refund policy?', answer: cancellationAnswer },
  { id: 'company-cancellation', question: 'What happens if VVPSS cancels or cannot provide my booked service?', answer: policy.companyCancellation },
  { id: 'hill-ac', question: 'Will the AC run on hill roads and slopes?', answer: policy.hillAC },
];
